import React, { useMemo } from 'react';

import { CloudInsight } from '@ariksa/inventory-core/api';
import { Box, Center, Circle, HStack, Stack, Text } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

import { getIcon, renderTime } from 'components/DataDisplay';

interface CloudInsightItemProps {
  item: CloudInsight;
  isLast?: boolean;
}

export const CloudInsightItem = (props: CloudInsightItemProps) => {
  const { item, isLast } = props;

  const circleColor = useMemo(() => {
    switch (item.category) {
      case 'Informational':
        return customTheme.colors.primary;
      case 'Elevated Risk':
        return customTheme.colors.red['500'];
      default:
        return customTheme.colors.red['500'];
    }
  }, [item.category]);

  return (
    <HStack spacing={5} alignItems="stretch" w="full" pr={10}>
      <Stack pos="relative" alignSelf="stretch" w="28px" minW="28px">
        <Center
          boxSize={8}
          pos="relative"
          color={circleColor}
          bg={colorOpacity(circleColor, 0.2)}
          borderRadius="full"
          p={1.5}
          overflow="hidden"
          zIndex={1}
        >
          <Center>{getIcon(item.category!)}</Center>
        </Center>
        {!isLast && (
          <Box
            w={'1px'}
            pos={'absolute'}
            top="32px"
            bottom={0}
            bg={customTheme.colors.gray['100']}
            left="15px"
            transform="translateX(-50%)"
            zIndex={0}
          />
        )}
      </Stack>
      <Stack w="full" pb={10}>
        <HStack spacing={6} justify="space-between">
          <Box fontWeight={600} fontSize="lg">
            {item.category ?? '-'}
          </Box>
          <Text color={customTheme.colors.gray['250']} fontSize="sm">
            {renderTime({ value: item.event_time })}
          </Text>
        </HStack>
        <Text h="full" overflow="auto">
          <Text
            color="primary"
            whiteSpace="nowrap"
            pr={1}
            display="inline-block"
          >
            {item.account_id + ':'}
          </Text>
          {item.description ?? '-'}
        </Text>
      </Stack>
    </HStack>
  );
};
